module.exports = __webpack_public_path__ + "media/ab-homepage/database-0bd92d3d.png";